module.exports = __webpack_public_path__ + "static/media/run_6.56744103.png";